// extracted by mini-css-extract-plugin
export default {"diary_wrap":"style_diary_wrap__v4ceD","list_box_wrap":"style_list_box_wrap__fSoCh","box":"style_box__cX3gZ","write_wrap":"style_write_wrap__nHcqj"};